/**
 * Generates an array of SEO meta tag objects based on the provided parameters.
 *
 * @param params - An object containing SEO properties.
 * @param params.title - The title of the page (required).
 * @param params.description - The description of the page (optional).
 * @param params.keywords - Comma-separated keywords relevant to the page (optional).
 * @param params.image - The URL of an image to use for social sharing (optional).
 * @returns An array of objects representing meta tags for SEO and social media.
 *
 * @example
 * const tags = seo({
 *   title: "My Page",
 *   description: "A description of my page.",
 *   keywords: "example, page, seo",
 *   image: "https://example.com/image.png"
 * });
 */
export const seo = ({
	title,
	description,
	keywords,
	image,
}: {
	title: string;
	description?: string;
	image?: string;
	keywords?: string;
}) => {
	const tags = [
		{ title },
		{ name: "description", content: description },
		{ name: "keywords", content: keywords },
		{ name: "twitter:title", content: title },
		{ name: "twitter:description", content: description },
		{ name: "twitter:creator", content: "@tannerlinsley" },
		{ name: "twitter:site", content: "@tannerlinsley" },
		{ name: "og:type", content: "website" },
		{ name: "og:title", content: title },
		{ name: "og:description", content: description },
		...(image
			? [
					{ name: "twitter:image", content: image },
					{ name: "twitter:card", content: "summary_large_image" },
					{ name: "og:image", content: image },
				]
			: []),
	];

	return tags;
};
